import script from "./PensionPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PensionPage.vue?vue&type=script&setup=true&lang=ts"

import "./PensionPage.vue?vue&type=style&index=0&id=c54cd320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c54cd320"]])

export default __exports__